import { Navigate, useRoutes } from "react-router-dom";
import SimpleLayout from "./layouts/simple";
import PosPage from "./pages/PosPage";
import Menu from "./pages/Selling/Menu";
import Tables from "./pages/Tables";
import Widgets from "./pages/Widgets";
import Items from "./pages/Items";
import { useContext } from "react";
import { AppContext } from "./AppContext";
import OrderTabs from "./pages/Tables/OrderTabs";
import ProductionCenter from "./pages/ProductionCenter/ProductionCenter";

// ----------------------------------------------------------------------

export default function Router() {
    const { isTabsPos } = useContext(AppContext);
    const routes = useRoutes([
        {
            path: "/tables",
            element: isTabsPos ? <OrderTabs /> : <Tables />,
        },
        {
            path: "/pos/:tableName/:orderName?",
            element: <PosPage />,
        },
        {
            path: "/items",
            element: <Items />,
        },
        {
            path: "/production-center",
            element: <ProductionCenter />,
        },
        {
            path: "/dashboard",
            children: [
                { element: <Navigate to="/dashboard/selling" />, index: true },
                { path: "menu", element: <Menu /> },
                { path: "widgets", element: <Widgets /> },
            ],
        },
        {
            element: <SimpleLayout />,
            children: [
                { element: <Navigate to="/tables" />, index: true },
                { path: "404", element: <Tables /> },
            ],
        },
    ]);

    return routes;
}
